import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";
import BookingModal from "../components/BookingModal";
const Header = ({ onBookingClick }) => {
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isHome = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { name: "Home", path: "/" },
    { name: "Projects", path: "/projects" },
    { name: "About", path: "/about" },
    { name: "Gallery", path: "/gallery" },
    { name: "Blog", path: "/blog" },
    { name: "Careers", path: "/careers" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <>
      {/* HEADER */}
      <header
        className={`left-0 right-0 z-50 transition-all duration-300
          ${
            isHome
              ? isScrolled
                ? "fixed top-0 bg-white shadow-sm"
                : "absolute top-0 bg-transparent"
              : "fixed top-0 bg-white shadow-sm"
          }
        `}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="h-16 flex items-center justify-between">
            {/* LOGO */}
            <Link to="/" className="flex items-center">
              <img
                src="https://customer-assets.emergentagent.com/job_90e5f1dd-7b5e-4f4a-a136-cf166cc550dd/artifacts/3hhr7glk_dvvLogo.jpg"
                alt="DVV Projects"
                className="h-10"
              />
            </Link>

            {/* DESKTOP NAV */}
            <nav className="hidden lg:flex gap-10">
              {links.map((link) => {
                const active = location.pathname === link.path;
                return (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`text-sm font-medium transition-colors duration-300
                      ${
                        active
                          ? "text-[#c9a24d]"
                          : isHome && !isScrolled
                          ? "text-white hover:text-[#c9a24d]"
                          : "text-brand-dark hover:text-[#c9a24d]"
                      }
                    `}
                  >
                    {link.name}
                  </Link>
                );
              })}
            </nav>

            {/* CTA BUTTON (UNCHANGED) */}
            <div className="hidden lg:flex items-center">
  <Button
    onClick={() => {
      setIsModalOpen(true);
      setOpen(false);
    }}
    className="btn-primary px-6 py-2.5 rounded-md font-semibold lg:w-auto w-full mt-0"
  >
    Book Site Visit
  </Button>
</div>



            {/* MOBILE MENU ICON */}
            <button
              onClick={() => setOpen(true)}
              className={`lg:hidden ${
                isHome && !isScrolled ? "text-white" : "text-brand-dark"
              }`}
            >
              <Menu size={26} />
            </button>
          </div>
        </div>

        {/* YELLOW LINE – AFTER SCROLL / OTHER PAGES */}
        {(isScrolled || !isHome) && <div className="h-[2px] bg-[#c9a24d]" />}
      </header>

      {/* MOBILE MENU */}
      {open && (
        <div className="fixed inset-0 bg-white z-50">
          <div className="flex justify-between items-center px-6 h-16 border-b">
            <span className="text-sm font-medium">MENU</span>
            <button onClick={() => setOpen(false)}>
              <X size={28} />
            </button>
          </div>

          <nav className="flex flex-col gap-6 px-6 pt-10">
            {links.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setOpen(false)}
                className={`text-lg font-medium transition-colors
                  ${
                    location.pathname === link.path
                      ? "text-[#c9a24d]"
                      : "text-brand-dark hover:text-[#c9a24d]"
                  }
                `}
              >
                {link.name}
              </Link>
            ))}

            <Button
              onClick={() => setIsModalOpen(true)}
              className="btn-primary px-6 py-2.5 rounded-md font-semibold w-full mt-6"
            >
              Book Site Visit
            </Button>
          </nav>
        </div>
      )}
      <BookingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Header;